"use client";
import * as React from 'react';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="container py-12">
      <h1 className="text-2xl font-semibold dark-text">Something went wrong</h1>
      <p className="mt-2 text-sm text-gray-700">{error.message}</p>
      <button
        className="mt-4 rounded-md px-4 py-2 text-white"
        style={{ backgroundColor: 'var(--color-primary)' }}
        onClick={() => reset()}
      >
        Try again
      </button>
    </div>
  );
}
